<div mat-dialog-title class="display-flex align-items-center justify-content-space-between modal-header">
  <span>{{ data.title }} change history</span>
  <button class="display-flex align-items-center justify-content-center" (click)="close()" mat-icon-button>
    <app-icon [svg]="EIcon.CLOSE" [iconWidth]="20" [iconHeight]="20" [iconColor]="EColorPalette.cGray"></app-icon>
  </button>
</div>

<ng-container *ngIf="!isLoading; else loadingTemplate">
  <ng-container *ngIf="dataSource?.data?.length > 0; else noHistoryTemplate">
    <mat-dialog-content>
      <div class="custom-field-history-table-wrapper">
        <table mat-table [dataSource]="dataSource">
          <ng-container matColumnDef="modified">
            <th mat-header-cell *matHeaderCellDef sticky>User & Date</th>
            <td mat-cell *matCellDef="let row">
              <div class="display-flex align-items-center grid-gap-6">
                <app-avatar [containerCss]="'s-24'" [userInfo]="getUser(row.modifiedBy)"></app-avatar>
                <span>{{ row.effectiveDate | date : 'MM/dd/yy hh:mm a' }}</span>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="value">
            <th mat-header-cell *matHeaderCellDef sticky>Value</th>
            <td mat-cell *matCellDef="let row">
              <div class="display-flex align-items-center grid-gap-6">
                <app-avatar
                  *ngIf="row.userIdValue"
                  [containerCss]="'s-24'"
                  [userInfo]="getUser(row.userIdValue)"></app-avatar>

                <ng-container *ngIf="getValue(row) as value">
                  <div *ngIf="value?.color" class="dropdown-color-circle" [ngStyle]="{ background: value.color }"></div>

                  <span *ngIf="value?.label">
                    <span *ngIf="value?.groupLabel" class="custom-dropdown-group-label">{{ value.groupLabel }}:</span>
                    {{ value.label }}
                  </span>
                </ng-container>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="deleted">
            <th mat-header-cell *matHeaderCellDef sticky></th>
            <td mat-cell *matCellDef="let row">
              <!-- <mat-icon class="icon-history" [matTooltip]="'Created'">playlist_add_check</mat-icon> -->
              <mat-icon class="icon-history" [matTooltip]="'Deleted'" *ngIf="row.isDeleted">playlist_remove</mat-icon>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
    </mat-dialog-content>
  </ng-container>
</ng-container>

<ng-template #loadingTemplate>
  <div class="display-flex align-items-center justify-content-center no-history-container history-loading-container">
    <mat-progress-spinner diameter="64" color="primary" mode="indeterminate"></mat-progress-spinner>
  </div>
</ng-template>

<ng-template #noHistoryTemplate>
  <div class="display-flex align-items-center justify-content-center no-history-container">
    <svg width="120" height="111" viewBox="0 0 120 111" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M64.2736 110.937C39.1671 111.73 11.2625 105.159 2.80298 81.588C-6.24967 56.3648 7.67981 29.6298 29.4556 13.9244C51.0926 -1.68081 80.5042 -5.85692 101.832 10.1651C122.239 25.4951 123.715 54.1758 114.817 78.0497C107.072 98.8316 86.5076 110.235 64.2736 110.937Z"
        fill="#4EB08D" />
      <path
        d="M13.1937 27.5932C13.1937 22.0517 17.6943 17.5593 23.2461 17.5593H99.8953C105.447 17.5593 109.948 22.0517 109.948 27.5932V91.5593C109.948 97.1009 105.447 101.593 99.8953 101.593H23.2461C17.6943 101.593 13.1937 97.1009 13.1937 91.5593V27.5932Z"
        fill="#D6D4D4" />
      <path
        d="M14.4503 28.8475C14.4503 23.3059 18.9509 18.8136 24.5026 18.8136H98.6387C104.191 18.8136 108.691 23.3059 108.691 28.8475V90.3051C108.691 95.8466 104.191 100.339 98.6387 100.339H24.5026C18.9509 100.339 14.4503 95.8466 14.4503 90.3051V28.8475Z"
        fill="white" />
      <path
        d="M91.0877 38.4846C90.589 39.0333 89.7252 39.0333 89.2265 38.4846L83.0855 31.7284C82.3529 30.9224 82.9258 29.6314 84.0161 29.6314H96.2981C97.3884 29.6314 97.9613 30.9224 97.2287 31.7284L91.0877 38.4846Z"
        fill="#4EB08D" />
      <path
        d="M25.7592 32.6102C25.7592 31.2248 26.8843 30.1017 28.2723 30.1017H60.9424C62.3303 30.1017 63.4555 31.2248 63.4555 32.6102V35.1186C63.4555 36.504 62.3303 37.6271 60.9424 37.6271H28.2723C26.8843 37.6271 25.7592 36.504 25.7592 35.1186V32.6102Z"
        fill="#DADADA" />
      <path
        d="M37.0681 33.8644C37.0681 37.3279 34.2552 40.1356 30.7853 40.1356C27.3155 40.1356 24.5026 37.3279 24.5026 33.8644C24.5026 30.4009 27.3155 27.5932 30.7853 27.5932C34.2552 27.5932 37.0681 30.4009 37.0681 33.8644Z"
        fill="#4EB08D" />
      <path
        d="M29.8429 30.7288C29.8429 30.2093 30.2649 29.7881 30.7853 29.7881C31.3058 29.7881 31.7277 30.2093 31.7277 30.7288V37C31.7277 37.5195 31.3058 37.9407 30.7853 37.9407C30.2649 37.9407 29.8429 37.5195 29.8429 37V30.7288Z"
        fill="white" />
      <path
        d="M27.644 34.8051C27.1235 34.8051 26.7016 34.3839 26.7016 33.8644C26.7016 33.3449 27.1235 32.9237 27.644 32.9237H33.9267C34.4472 32.9237 34.8691 33.3449 34.8691 33.8644C34.8691 34.3839 34.4472 34.8051 33.9267 34.8051H27.644Z"
        fill="white" />
      <path
        d="M24.5026 48.2881C24.5026 46.9027 25.6278 45.7797 27.0157 45.7797H96.1256C97.5136 45.7797 98.6387 46.9027 98.6387 48.2881V87.1695C98.6387 88.5549 97.5136 89.678 96.1256 89.678H27.0157C25.6278 89.678 24.5026 88.5549 24.5026 87.1695V48.2881Z"
        fill="#D6D4D4" />
      <path
        d="M25.7592 49.5424C25.7592 48.157 26.8843 47.0339 28.2723 47.0339H94.8691C96.257 47.0339 97.3822 48.157 97.3822 49.5424V85.9153C97.3822 87.3006 96.257 88.4237 94.8691 88.4237H28.2722C26.8843 88.4237 25.7592 87.3006 25.7592 85.9153V49.5424Z"
        fill="#EEEEEE" />
      <path
        d="M33.2984 58.9492C33.2984 57.5638 34.4236 56.4407 35.8115 56.4407H87.3298C88.7178 56.4407 89.8429 57.5638 89.8429 58.9492V62.7119C89.8429 64.0973 88.7178 65.2203 87.3298 65.2203H35.8115C34.4236 65.2203 33.2984 64.0973 33.2984 62.7119V58.9492Z"
        fill="#83C8AF" />
      <path
        d="M33.2984 58.9492C33.2984 57.5638 34.4236 56.4407 35.8115 56.4407H87.3298C88.7178 56.4407 89.8429 57.5638 89.8429 58.9492V61.4576C89.8429 62.843 88.7178 63.9661 87.3298 63.9661H35.8115C34.4236 63.9661 33.2984 62.843 33.2984 61.4576V58.9492Z"
        fill="#4EB08D" />
      <path
        d="M33.2984 72.7458C33.2984 71.3604 34.4236 70.2373 35.8115 70.2373H87.3298C88.7178 70.2373 89.8429 71.3604 89.8429 72.7458V76.5085C89.8429 77.8939 88.7178 79.017 87.3298 79.017H35.8115C34.4236 79.017 33.2984 77.8939 33.2984 76.5085V72.7458Z"
        fill="#83C8AF" />
      <path
        d="M33.2984 72.7458C33.2984 71.3604 34.4236 70.2373 35.8115 70.2373H87.3298C88.7178 70.2373 89.8429 71.3604 89.8429 72.7458V75.2542C89.8429 76.6396 88.7178 77.7627 87.3298 77.7627H35.8115C34.4236 77.7627 33.2984 76.6396 33.2984 75.2542V72.7458Z"
        fill="#4EB08D" />
    </svg>
  </div>
</ng-template>
